var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcArrowleft16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_arrowleft16",
    transform: "translate(-494.25 -372.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 16,
    height: 16,
    transform: "translate(494.25 372.25)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4460",
    "data-name": "Path 4460",
    d: "M5.906,0a1.089,1.089,0,0,1-.794-.342L1.175-4.5a1.092,1.092,0,0,1,0-1.5l3.937-4.156A1.091,1.091,0,0,1,6.659-10.2,1.093,1.093,0,0,1,6.7-8.654L3.475-5.25,6.7-1.846A1.093,1.093,0,0,1,6.659-.3,1.089,1.089,0,0,1,5.906,0Z",
    transform: "translate(498.313 385.5)",
    fill: "#a0a3c4"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowleft16);
export default __webpack_public_path__ + "static/media/ic_arrowleft16.9d2319ed90125dd1a7f0e1abfb0a5d6d.svg";
export { ForwardRef as ReactComponent };